/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import api from '../../services/service_item'
import api_ser from '../../services/service'
export default {
  data () {
    return {
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      modal_active: false,
      id_receive: null,
      tmp_data: {
        'barcode': '',
        'rate_1': 0,
        'unit_code': '',
        'is_default': 0,
        'price_1': 0,
        'price_2': 0,
        'price_3': 0,
        'price_4': 0,
        'price_5': 0,
        'price_6': 0,
        'price_active': 1
      },
      previewVisible: false,
      previewImage: '',
      temp_code: 'xxxxxxxx',
      item_detail: {
        'id': 0,
        'code': '',
        'name': '',
        'short_name': '',
        'name_en': '',
        'name_cn': '',
        'stk_unit_code': '',
        'stock_type': 0,
        'menu_id': 0,
        'menu_seq': 0,
        'depart_code': '',
        'color_code': '',
        'item_type': '',
        'category_code': '',
        'image_1': '',
        'group_code': '',
        'description': '',
        'stock_min': 1,
        'stock_qty': 0,
        'weight': 1,
        'is_return': 0,
        'is_expired': 0,
        'create_by': '',
        'edit_by': '',
        'active_status': 1,
        'bar_data': []
      },
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        // }
      ],
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {span: 8},
        wrapperCol: {span: 16}
      },
      tailFormItemLayout: {
        wrapperCol: {
          span: 16,
          offset: 8
        }
      },
      unit: [],
      catagory: [],
      group: [],
      department: [],
      item_type: [],
      item: null,
      item_color: [
        {'code': 'green', 'name': 'เขียว'},
        {'code': 'yellow', 'name': 'เหลือง'},
        {'code': 'orange', 'name': 'ส้ม'},
        {'code': '#00FF00', 'name': 'เขียวอ่อน'},
        {'code': '#00FFFF', 'name': 'ฟ้าอ่อน'},
        {'code': 'gray', 'name': 'เทา'}
      ]
    }
  },
  methods: {
    status_is_process (val) {
      switch (val) {
        case 1:
          return 'กำลังคำนวน'
        case 0:
          return 'สำเร็จ'
        default:
          return 'ไม่พบสถานะ'
      }
    },
    onChange (checked) {
      if (checked == false) {
        this.item_detail.active_status = 0
      }
      if (checked == true) {
        this.item_detail.active_status = 1
      }
      console.log(this.item_detail.active_status)
    },
    handleCancel () {
      this.previewVisible = false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList }) {
      this.fileList = fileList
    },
    getUnit () {
      api.itemUnit(this.REST_URL,
        this.header, {},
        result => {
          if (result.response === 'success') {
            this.unit = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหน่วยนับไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getGroup () {
      api.itemGroup(this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.group = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลกลุ่มสินค้าไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    itemCatagory () {
      api.itemCatagory(this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.catagory = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหมวดหมู่ไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    itemDepartment () {
      api.itemDepartment(this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.department = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลแผนกไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getItem () {
      this.$store.commit('Loading')
      api.itemById(this.REST_URL,
        this.header,
        {'id': parseInt(this.id_receive)},
        result => {
          if (result.response === 'success') {
            this.item_detail = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหน่วยนับไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    itemType () {
      this.code = '1001'
      api.itemType(this.REST_URL,
        this.header,
        {'barcode': this.code},
        result => {
          if (result.response === 'success') {
            this.item_type = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลหน่วยนับไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    confirmData () {
      for (let i = 0; i < this.item_detail.bar_data.length; i++) {
        this.item_detail.bar_data[i].price_1 = parseInt(this.item_detail.bar_data[i].price_1)
        this.item_detail.bar_data[i].price_2 = parseInt(this.item_detail.bar_data[i].price_2)
        this.item_detail.bar_data[i].price_3 = parseInt(this.item_detail.bar_data[i].price_3)
      }
      // console.log(JSON.stringify(this.item_detail))
      this.addItem()
    },
    close_modal () {
      this.modal_active = false
      this.tmp_data = {
        'barcode': '',
        'rate_1': 0,
        'unit_code': '',
        'is_default': 0,
        'price_1': 0,
        'price_2': 0,
        'price_3': 0,
        'price_4': 0,
        'price_5': 0,
        'price_6': 0,
        'price_active': 1
      }
    },
    add_subitem () {
      var index = this.item_detail.bar_data.findIndex(x => x.barcode === this.tmp_data.barcode)
      if (index < 0) {
        this.item_detail.bar_data.push(this.tmp_data)
        this.close_modal()
      } else {
        this.item_detail.bar_data[index] = this.tmp_data
        this.close_modal()
      }
    },
    reDataSubitem (val) {
      console.log(val)
      for (let index = 0; index < this.item_detail.bar_data.length; index++) {
        if (val != index) {
          this.item_detail.bar_data[index].is_default = 0
        }
      }
    },
    addItem () {
      console.log(JSON.stringify(this.item_detail))
      api.itemAdd(this.REST_URL,
        this.header,
        this.item_detail,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'แก้ไขข้อมูลผู้ใช้งานสำเร็จ',
              description: result.message
            })
            this.$router.push('/itemlist')
          } else {
            console.log(result)
            this.$notification['warning']({
              message: 'ดึงข้อมูลหน่วยนับไม่ได้',
              description: result
            })
          }
        },
        error => {
          console.log(error)
          this.$notification['error']({
            message: 'ข้อมูลไม่ถูกต้อง',
            description: error.data.error
          })
          // alert('ไม่สามารถเข้าถึงข้อมูล ' + error)
        }
      )
    },
    remove_sub (index) {
      console.log(index)
      this.item_detail.bar_data.splice(index, 1)
    },
    uploadImgDefault () {
      var imagefile = document.querySelector('#imgDefault')
      if (imagefile.files.length > 0) {
        let formData = new FormData()
        formData.append('myFile', imagefile.files[0])
        formData.append('type', 'product')
        api_ser.uploadImage(
          this.REST_URL,
          this.header,
          formData,
          result => {
            if (result.response === 'success') {
              this.item_detail.image_1 = result.data.url
            } else {
              alert(result.message)
            }
          },
          error => {
            alert(JSON.stringify(error))
          }
        )
      }
    }
  },
  created () {
    this.getUnit()
    this.getGroup()
    this.itemCatagory()
    this.itemType()
    this.itemDepartment()
  },
  mounted () {
    this.id_receive = this.$route.params.id
    if (this.id_receive != null && this.id_receive != 0) {
      this.getItem()
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/manage_item.js